import styled from 'styled-components';

import { getThemeColor, getThemeTransition, media } from '@utils/styled';

import Typography from '@common/components/Typography';

export const FilterCategory = styled.div`
  display: block;

  ${
    /* sc-block */ media.from960up`
    display: block;
    flex: 1;
    border-right: 1px solid ${getThemeColor('bluegrey.80')};
    padding: 0 2rem;
    ${({ theme }) => theme.getFluidSpacing('padding-bottom', 'scale', 0)};

    &:first-of-type {
      padding-left: 0;
    }

    &:last-of-type {
      border-right: 0;
      padding-right: 0;
    }
  `
  }
`;

export const MobileSelectedSortInfo = styled(Typography).attrs({
  customAs: 'span',
  variant: 'body2',
})`
  margin-bottom: 0;
  margin-left: 1rem;
  padding-top: 2px;
  color: ${getThemeColor('bluegrey.70')};

  ${media.from960up`
    display: none;
  `}
`;

export const FiltersListContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({ isMobileSectionOpen }) => (isMobileSectionOpen ? 2 : 1)};
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'widthBased', 0)};
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'widthBased', 0)};
  padding-bottom: ${({ hasFiltersSelected }) =>
    hasFiltersSelected ? '14.1rem' : '8.1rem'};
  background: ${getThemeColor('grey.100')};
  transition: ${getThemeTransition('padding-bottom', 'slow')};
  transform: translateX(100%);
  ${({ isMobileSectionOpen }) =>
    !isMobileSectionOpen ? 'display: none;' : null};

  ${media.from960up`
    display: flex;
    position: static;
    transform: none;
    width: auto;
    height: auto;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  `}
`;

export const FilterListContent = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  ${({ theme }) => theme.getFluidSpacing('margin-left', 'widthBased', 0, true)};
  ${({ theme }) =>
    theme.getFluidSpacing('margin-right', 'widthBased', 0, true)};

  ${media.from960up`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const MobileFiltersListContainer = styled.div`
  overflow: auto;
  max-height: 100%;
  ${({ theme }) => theme.getFluidSpacing('padding-left', 'widthBased', 0)};
  ${({ theme }) => theme.getFluidSpacing('padding-right', 'widthBased', 0)};
  padding-bottom: 6rem;

  ${media.from960up`
    padding-left: 0;
    padding-right: 0;
  `}
`;

export const FiltersListTitleContainer = styled.div`
  display: flex;
  flex: 0 0 6rem;
  align-items: center;
  border-bottom: 1px solid ${getThemeColor('bluegrey.80')};

  ${media.from960up`
    display: none;
  `}
`;

export const FiltersListBackButton = styled.div`
  display: inline-block;
  margin-right: 0.9rem;
  color: ${getThemeColor('bluegrey.70')};
  font-size: 0;
  cursor: pointer;

  svg {
    fill: currentColor;
  }
`;

export const MobileSubmenuIcon = styled.div`
  flex: 0 0 auto;
  margin-left: auto;
  color: ${getThemeColor('bluegrey.70')};

  svg {
    fill: currentColor;
  }

  ${media.from960up`
    display: none;
  `}
`;

export const FiltersListTitle = styled(Typography).attrs({
  customAs: 'div',
  variant: 'body1',
})`
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.15')};
  font-weight: 500;
`;

export const FiltersList = styled.div`
  flex: 1 1 auto;
`;

export const SubcategoryTitle = styled(Typography).attrs({
  customAs: 'h4',
  variant: 'body2',
})`
  margin-top: 5rem;
  margin-bottom: 0;
  border-bottom: 1px solid ${getThemeColor('bluegrey.90')};
  padding-bottom: 1rem;
  color: ${getThemeColor('bluegrey.60')};
  font-weight: 500;
  line-height: 1;

  &:first-child {
    margin-top: 3rem;
  }
`;

export const CategoryTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 6.4rem;
  border-bottom: 1px solid ${getThemeColor('bluegrey.80')};
  cursor: pointer;

  ${media.from960up`
    pointer-events: none;
    height: 5rem;
  `}
`;

export const CategoryTitle = styled(Typography).attrs({
  customAs: 'h3',
  variant: 'paragraph2',
})`
  display: inline-block;
  margin-bottom: 0;
  color: ${getThemeColor('bluegrey.15')};
`;

export const LoadingFilters = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
`;
